<template>
  <div class="page-bg page">
    <SubHeader
      :title="headerTitle"
      :isBack="true"
      :right-text="isModify ? '完成' : '管理'"
      @submit="isModify = !isModify"
    ></SubHeader>

    <div class="main">
      <div class="page-content">
        <div class="address-body">
          <div class="address-list" v-show="address.length > 0">
            <div class="item" v-for="(item, index) in address" :key="index">
              <div class="item-header">
                <div class="item-img"><img :src="userInfo.avatar" /></div>
                <div class="item-info">
                  <div class="title">
                    <div class="name-phone">
                      {{ item.name }} {{ item.phone }}
                    </div>
                    <div
                      class="set"
                      v-show="parseInt(item.isdefault) === 1"
                    ></div>
                  </div>
                  <div class="desc">
                    {{ item.province + item.city + item.county + item.address }}
                  </div>
                </div>
                <div
                  class="modify-icon"
                  @click="$router.push('/user/address/edit?id=' + item.id)"
                ></div>
              </div>
              <div class="item-footer" v-show="isModify">
                <span
                  class="radio-wrap"
                  @click="modifyDefault(item.id, index)"
                  :class="{ active: parseInt(item.isdefault) === 1 }"
                  >默认地址</span
                >
                <span class="del" @click="delAddressBtn(item.id, index)"
                  >删除</span
                >
              </div>
            </div>
          </div>
          <div class="empty" v-show="!address.length > 0">
            <div class="empty-img"></div>
            <div>您还没有地址哦，快来添加吧～</div>
          </div>

          <div class="address-btn">
            <div class="set-btn" @click="$router.push('/user/address/edit')">
              新增收货地址
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import SubHeader from "../../../components/sub_header";

import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { Dialog, Toast } from "vant";

Vue.use(Dialog);

export default {
  name: "user-address",
  data() {
    return {
      isModify: false,
      list: [],
    };
  },
  components: {
    SubHeader,
    [Dialog.Component.name]: Dialog.Component,
  },

  created() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;

    let toastLoading = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
    });
    this.getAddress({
      success: (res) => {
        console.log(res);
        toastLoading.clear();
      },
    });
  },
  methods: {
    ...mapActions({
      getAddress: "address/getAddress",
      setDefAddress: "address/setDefAddress",
      delAddress: "address/delAddress",
    }),

    modifyDefault(id, index) {
      console.log(id);

      // if(this.address[index].isdefault === 1){
      //     Toast("最后一个地址，不可取消默认操作");
      //     return false;
      // }

      let data = {
        id: id,
        index: index,
      };

      let toastLoading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
      });

      this.setDefAddress({
        data: data,
        success: (res) => {
          toastLoading.clear();
          if (res.status == 1) {
            Toast("操作成功");
          } else {
            Toast(res.message);
          }
        },
      });

      // this.isModify = !this.isModify;
    },

    delAddressBtn(id, index) {
      let data = {
        id: id,
        index: index,
      };

      let vm = this;

      Dialog.confirm({
        title: "提示",
        message: "确定要删除改地址吗？",
        className: "dialog-public",
      })
        .then(() => {
          let toastLoading = Toast.loading({
            duration: 0,
            forbidClick: true,
          });

          vm.delAddress({
            data: data,
            success: (res) => {
              toastLoading.clear();
              if (res.status == 1) {
                Toast("操作成功");
              } else {
                Toast(res.message);
              }
            },
          });
        })
        .catch(() => {
          // on cancel
        });

      // this.isModify = !this.isModify;
    },
  },
  computed: {
    ...mapState({
      address: (state) => state.address.address,
      userInfo: (state) => state.user.userInfo,
    }),
  },

  mounted() {},

  activated() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  background-size: cover;
  box-sizing: border-box;
  height: 100vh;
}

.main {
  width: 100%;
  box-sizing: border-box;
  height: calc(100vh - 1.45rem);
  position: relative;
}
.page-content {
  position: relative;
  overflow-y: auto;
  height: 100%;
}

.empty {
  font-size: 0.28rem;
  color: #333234;
  text-align: center;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
  .empty-img {
    background-image: url(../../../assets/images/user/set/address_no.png);
    width: 2.29rem;
    height: 2.33rem;
    background-size: 100%;
    margin: 0 auto;
    margin-bottom: 0.24rem;
  }
}

.address-list {
  padding-top: 0.4rem;
  padding-bottom: 1.4rem;
  .item {
    background: url(../../../assets/images/user/set/bg.png) repeat-y left top;
    background-size: 100% auto;
    margin-bottom: 0.5rem;
    .item-header {
      padding: 0.2rem 0.36rem 0.2rem 0.5rem;
      display: flex;
      align-items: center;
      .item-img {
        width: 0.95rem;
        height: 0.95rem;
        box-sizing: border-box;
        border-radius: 50%;
        overflow: hidden;
        border: 2px solid #2b2b2a;
        margin-right: 0.23rem;
        font-size: 0;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .item-info {
        flex: 1;

        .title {
          font-size: 0.3rem;
          color: #3d3d3d;
          display: flex;
          align-items: center;
          line-height: 1;

          .set {
            margin-left: 0.16rem;
            width: 0.58rem;
            height: 0.25rem;
            background: url(../../../assets/images/user/set/ic2.png) no-repeat
              center;
            background-size: 100%;
          }
        }
        .desc {
          line-height: 1.2;
          margin-top: 0.2rem;
          color: #818181;
          font-size: 0.24rem;
        }
      }
      .modify-icon {
        width: 0.35rem;
        height: 0.45rem;
        background: url(../../../assets/images/user/set/ic3.png) no-repeat
          center;
        background-size: 100%;
      }
    }
    .item-footer {
      padding: 0 0.8rem 0 1.54rem;
      border-top: 1px solid #818181;
      height: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.24rem;
      line-height: 1;
      .radio-wrap {
        cursor: pointer;
        padding-left: 0.4rem;
        background-position: left center;
        background-repeat: no-repeat;
        background-image: url(../../../assets/images/user/set/ic1.png);
        background-size: auto 0.26rem;
        &.active {
          background-image: url(../../../assets/images/user/set/ic1-on.png);
        }
      }
      .del {
        color: #f68d2f;
      }
    }
  }
}

.set-wrap {
  margin-bottom: 0.3rem;
  .set-title {
    font-size: 0.3rem;
    color: #333234;
    line-height: 1rem;
    padding: 0 0.55rem;
    font-weight: bold;
  }

  .set-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: url(../../../assets/images/user/set/bg.png) repeat-y left top;
    background-size: 100% auto;
    height: 0.8rem;
    padding: 0 0.68rem 0 0.55rem;

    .t {
      font-size: 0.3rem;
      color: #333234;
    }
    .des {
      font-size: 0.3rem;
      color: #5c5c5c;
      display: flex;
      align-items: center;
      height: 100%;
      padding-right: 0.3rem;
      position: relative;

      span.icon {
        width: 0.12rem;
        height: 0.24rem;
        background: url(../../../assets/images/user/set/right.png) no-repeat
          center;
        background-size: 100%;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -0.12rem;
      }
    }
  }
}

.address-btn {
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 0.5rem;
}
</style>

